import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from '../AppConstants';
import { LoginModalService } from '../login-modal.service';
import { UIRoutes } from '../UIRoutes';
import { AuthService } from '../service/auth.service';
import { CapacitorPlatformService } from '../service/capacitor-platform.service';
import { SocialAuthService } from "@abacritt/angularx-social-login";
import {  GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { HttpErrorResponse } from '@angular/common/http';

import { GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { SocialUser } from '@abacritt/angularx-social-login';
import { GoogleAuth, User as NativeGoogleUser } from '@codetrix-studio/capacitor-google-auth';

import { ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';


declare var gtag: Function;  // Declare the global gtag function

// This lets me use jquery
declare var $: any;

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnInit {
  @ViewChild('accountDropdown') accountDropdown: NgbDropdown;
  mobileMenuOpen = false;
  loginDisplayText;
  externalUserContext;
  currentUserContext;
  roleId;
  logInStatus = false;
  user: SocialUser | undefined;
  GoogleLoginProvider = GoogleLoginProvider;
  isNativeApp = false;
  nativeGoogleSignInError = '';

  //Moved from bc
    minPasswordLength = 8;
    signUpFormGroup: FormGroup;
    signInFormGroup: FormGroup;
    forgotPasswordFormGroup: FormGroup;
    verifyOTPFormGroup: FormGroup;
    resetPasswordFormGroup: FormGroup;
    phoneNumberFormGroup: FormGroup;
    showSignInForm = true;
    showSignUpForm = false;
    showForgotPasswordForm = false;
    showResetPasswordForm = false;
    showPhoneNumberForm = false;
    userEmail = '';
    sendOTPClicked = false;
    disabledNoOfCasesDiv = false;
    messageToDisplayAfterOtpSent = '';
    showSignInError;
    signInError = '';

   // mobile = false;
    //loginModalSubscription: Subscription;
    showModal = false;
    roleIdForSignUp;
    modalReference;
    onClickVerifyError;
    showOnClickVerifyError;
    sendOTPerror:boolean = false;
    onClickResetPasswordError;
    showOnClickResetPasswordError;
    isPasswordTyped: boolean = false;
    showPassword: boolean = false;
    userExistsError: boolean = false;
    phoneUpdateError = '';
    userDetails;
//moved from bc end
  private routerSubscription: any;
  private loginAttemptUrl = '';

  @ViewChild('content', {static: false})
    private content: TemplateRef<any>;

  constructor(
    private router: Router,
    private loginModalService: LoginModalService,
    private authService: AuthService,
    private capacitorPlatformService: CapacitorPlatformService,
    private readonly socialAuthService: SocialAuthService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {

    this.isNativeApp = this.capacitorPlatformService.isNative();
    this.showOnClickVerifyError = false;
    this.userExistsError = false;
    this.showSignInError = false;
    this.externalUserContext =  this.authService.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT);
    this.currentUserContext = this.authService.getStoredItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
    if(this.externalUserContext) {
      this.loginDisplayText = JSON.parse(this.externalUserContext).firstName;
    } else if(this.currentUserContext) {
      //console.log(this.currentUserContext);
      this.loginDisplayText = JSON.parse(this.currentUserContext).firstName;
    } else {
      this.loginDisplayText = '';
    }

    this.isLoggedIn();

    this.socialAuthService.authState.subscribe((user) => {
      console.log("User logged in via - Gmail -> " + user)
      if (!user || !user.idToken) {
        return;
      }

      this.user = user;

      this.authService.loginWithSocialUser(user).subscribe(
        loginResponse => {
          console.log(loginResponse);
          this.handlePostLogin();
        },
        (errorLoginResponse: HttpErrorResponse) => {
          console.log(errorLoginResponse);
        }
      );

    });

   // Subscribe to router events
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.collapseMenu();
          }
      });

      //Added for movement
      this.loginModalService.getLoginModalData()
      .subscribe(data => {

        /* if(data.showModal) {
          this.displayLoginModalPopup();
        } */


        if(data.showModal) {
          console.log("Display ngOnInit", data);
          this.showSignInForm = !data.showModal.showSignUpForm;
          this.showSignUpForm = data.showModal.showSignUpForm;

          if(data.showModal.roleIdForSignUp) {
            this.roleIdForSignUp = data.showModal.roleIdForSignUp;
          }

          console.log("showSignInForm", this.showSignInForm);
          console.log("showSignUpForm", this.showSignUpForm);
          console.log("roleIdForSignUp", this.roleIdForSignUp);
          this.displayLoginModalPopup();
        }

      });

      //Moved Login Modal related



      this.signUpFormGroup = new FormGroup({
            emailFormControl: new FormControl('', [
              Validators.required,
              Validators.email,
            ]),
            firstNameFormControl: new FormControl('', [
              Validators.required,
              Validators.pattern('^[a-zA-Z]+$')
            ]),
            lastNameFormControl: new FormControl('', [
              Validators.required,
              Validators.pattern('^[a-zA-Z]+$')
            ]),
            phoneNoFormControl: new FormControl('', [
              Validators.required,
              Validators.pattern('^[0-9]{10}$')
            ]),
            checkboxFormControl: new FormControl(false, [
              Validators.requiredTrue
            ])
          });

          this.signInFormGroup = new FormGroup({
            emailFormControl: new FormControl('', [
              Validators.required,
              Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
            ]),
            passwordFormControl: new FormControl('', [
              Validators.required
            ])
          });

          this.forgotPasswordFormGroup = new FormGroup({
            emailFormControl: new FormControl('', [
              Validators.required,
              Validators.email,
            ]),
            // passwordFormControl: new FormControl('', [
            //   Validators.required
            // ])
          });

          this.verifyOTPFormGroup = new FormGroup({
            regotp0: new FormControl('', [
              Validators.required, Validators.pattern('^[0-9]*$')
            ]),
            regotp1: new FormControl('', [
              Validators.required, Validators.pattern('^[0-9]*$')
            ]),
            regotp2: new FormControl('', [
              Validators.required, Validators.pattern('^[0-9]*$')
            ]),
            regotp3: new FormControl('', [
              Validators.required, Validators.pattern('^[0-9]*$')
            ])
          });

          this.resetPasswordFormGroup = this.formBuilder.group({
            passwordFormControl: new FormControl('', [
              Validators.required,
              Validators.minLength(this.minPasswordLength),
              // Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
              // Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&-+=()])(?=\\S+$).{8, 20}$')

              Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,20}")
            ]),
            reenterPasswordFormControl: new FormControl('', [
              Validators.required
            ])
          }, { validator: this.checkPasswords });

          this.phoneNumberFormGroup = new FormGroup({
            phoneNumberFormControl: new FormControl('', [
              Validators.required,
              Validators.pattern('^[6-9][0-9]{9}$')
            ])
          });




  }

  ngOnDestroy() {
      if (this.routerSubscription) {
        this.routerSubscription.unsubscribe(); // Clean up subscription
      }
    }

  getLoginDisplayText() {
    this.externalUserContext =  this.authService.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT);
    this.currentUserContext = this.authService.getStoredItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
    if(this.externalUserContext) {
      this.loginDisplayText = JSON.parse(this.externalUserContext).firstName;
    } else if(this.currentUserContext) {
      this.loginDisplayText = JSON.parse(this.currentUserContext).firstName;
    } else {
      this.loginDisplayText = '';
    }
    return this.loginDisplayText;
  }

  onClickLogin() {
    this.menu();
    this.loginModalService.setLoginModalData(true);
    console.log(" Login Modal True : Top bar");
  }

  clickedLogout() {
    this.authService.clearStoredAuth();
    this.router.navigateByUrl('').then(() => {
      window.location.reload();
    });
  }
  activateCurrentLinkTab() {
    var element = document.getElementById("nav-link");
    console.log("element: ", element);
    element.classList.add("active");

  }
/*   activateCurrentLinkTab() {
      var element = document.getElementById("ham-menu");
      element.classList.find('li.active').remove("active");
      this.parent('li').add("active");

    } */
  onClickAdmin()
  {
    this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_DASHBOARD]);
  }

  onClickTenants()
  {
    if (this.roleId == 1)
    {
      this.router.navigate([UIRoutes.ROUTING_MODULE_TENANTS_GRID]);
    }
  }

  onClickUsers()
  {
     if (this.roleId == 1)
     {
       this.router.navigate([UIRoutes.ROUTING_MODULE_USERS]);
     }
  }

  onClickPayment() {
    if(this.roleId == 1) {
      this.router.navigate([UIRoutes.ROUTING_MODULE_PAYMENT])
    }
  }

  clickedOnAdminBookings() {
      this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_ADMIN_BOOKINGS_PAGE]);
      //sessionStorage.setItem(AppConstants.SESSION_STORAGE_CLICKED_TAB, AppConstants.TAB_ADMIN_BOOKINGS);
  }
  clickedOnTransactions() {
        this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_TRANSACTIONS]);
        //sessionStorage.setItem(AppConstants.SESSION_STORAGE_CLICKED_TAB, AppConstants.TAB_COMPANY_PROFILE);
  }
  clickedOnReports() {
      this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_REPORTS]);
      //sessionStorage.setItem(AppConstants.SESSION_STORAGE_CLICKED_TAB, AppConstants.TAB_COMPANY_PROFILE);
  }
  clickedOnCompanyProfile() {
      this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_COMPANY_PROFILE]);
      //sessionStorage.setItem(AppConstants.SESSION_STORAGE_CLICKED_TAB, AppConstants.TAB_COMPANY_PROFILE);
  }
  clickedOnProducts() {
    this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_PRODUCTS]);
    //sessionStorage.setItem(AppConstants.SESSION_STORAGE_CLICKED_TAB, AppConstants.TAB_PRODUCTS);
  }

  clickedOnVenues() {
    this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_VENUES]);
    //sessionStorage.setItem(AppConstants.SESSION_STORAGE_CLICKED_TAB, AppConstants.TAB_VENUES);
  }
  clickedProfile() {
      console.log("Proifile Clicked");
      this.router.navigate([UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_PROFILE]);
      //sessionStorage.setItem(AppConstants.SESSION_STORAGE_CLICKED_TAB, AppConstants.TAB_VENUES);
  }
  isLoggedIn() {

    if(this.externalUserContext) {
        this.roleId = JSON.parse(this.externalUserContext).roleId;
      } else if(this.currentUserContext) {
        this.roleId = JSON.parse(this.currentUserContext).roleId;
      } else {
        this.roleId = 0; // user not logged in
     }

    if(this.authService.getStoredItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT)) {
      this.logInStatus = true;
    } else if(this.authService.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT) && JSON.parse(this.authService.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT)).status == 'Inactive') {
      this.logInStatus = false;
    } else if(this.authService.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT)) {
      this.logInStatus = true;
    }
    //console.log("TBar: ", this.logInStatus);
    return this.logInStatus;
  }

  menu()
  {
    this.collapseMenu();
  }
 collapseMenu() {
    this.mobileMenuOpen = false;
    this.accountDropdown?.close();
  }

  closeMobileMenu() {
    if (!this.mobileMenuOpen) return;
    this.collapseMenu();
    (document.querySelector('.brand-menu-toggle') as HTMLElement)?.focus();
  }


  socialSignIn(): void {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  async nativeGoogleSignIn(): Promise<void> {
    this.nativeGoogleSignInError = '';

    try {
      await GoogleAuth.signOut().catch(() => undefined);
      const googleUser = await GoogleAuth.signIn();
      const socialUser = this.toSocialLoginUser(googleUser);

      this.authService.loginWithSocialUser(socialUser).subscribe(
        loginResponse => {
          console.log(loginResponse);
          this.modalReference.dismiss();
          this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_SIGN_UP_SUCCESS);
        },
        (errorLoginResponse: HttpErrorResponse) => {
          console.log(errorLoginResponse);
          this.nativeGoogleSignInError = this.getLoginErrorMessage(errorLoginResponse);
        }
      );
    } catch (error) {
      console.error('Native Google sign-in failed', error);
      this.nativeGoogleSignInError = this.getNativeGoogleSignInErrorMessage(error);
    }
  }

  private toSocialLoginUser(googleUser: NativeGoogleUser): any {
    return {
      email: googleUser.email,
      firstName: googleUser.givenName,
      lastName: googleUser.familyName,
      idToken: googleUser.authentication && googleUser.authentication.idToken,
      provider: GoogleLoginProvider.PROVIDER_ID
    };
  }

  private getLoginErrorMessage(error: HttpErrorResponse): string {
    if (error.error && error.error.errors && error.error.errors.length) {
      return error.error.errors[0].message;
    }

    return 'Unable to sign in with Google. Please try again.';
  }

  private getNativeGoogleSignInErrorMessage(error: any): string {
    const detailParts = [
      error?.message || error?.errorMessage,
      error?.code ? `code ${error.code}` : '',
      error?.type ? `type ${error.type}` : ''
    ].filter(Boolean);
    const detail = detailParts.length ? detailParts.join(', ') : JSON.stringify(error);

    return detail
      ? `Unable to sign in with Google: ${detail}`
      : 'Unable to sign in with Google. Please try again.';
  }

  //Moved methods

  displayLoginModalPopup() {
      this.clearAuthenticationErrors();
     console.log("displayLoginModalPopup");
      this.loginAttemptUrl = this.router.url;

      //this.roleIdForSignUp = 3;
      this.modalReference = this.modalService.open(this.content, { windowClass: 'bottom-container', ariaLabelledBy: 'modal-basic-title'});
    }

    onClickCreateNow() {
      this.clearAuthenticationErrors();
      console.log("onClickCreateNow");
      this.roleIdForSignUp = 2;
      this.showSignInForm = false;
      this.showForgotPasswordForm = false;
      this.showSignUpForm = true;
      this.modalReference = this.modalService.open(this.content, { windowClass: 'bottom-container', ariaLabelledBy: 'modal-basic-title'});

      // Google Analytics custom event tracking
      gtag('event', 'register_business', {
            method: 'Button Click'
      });
    }
    onClickSignUpEndUser() {
        this.clearAuthenticationErrors();
        console.log("onClickCreateNow");
        this.roleIdForSignUp = 3;
        this.showSignInForm = false;
        this.showForgotPasswordForm = false;
        this.showSignUpForm = true;
        this.modalReference = this.modalService.open(this.content, { windowClass: 'bottom-container', ariaLabelledBy: 'modal-basic-title'});

        // Google Analytics custom event tracking
            gtag('event', 'sign_up', {
              method: 'Button Click'
            });
    }

    onGetStartedClicked() {


       if (this.signUpFormGroup.invalid) {
            this.signUpFormGroup.markAllAsTouched(); // Mark all fields as touched to trigger validation messages
            return;
       }
       else
       {

          console.log( "Role Id:", this.roleIdForSignUp );
          this.authService.createExternalUser(this.signUpFormGroup.get('firstNameFormControl').value,
              this.signUpFormGroup.get('lastNameFormControl').value, this.signUpFormGroup.get('emailFormControl').value, this.roleIdForSignUp, this.signUpFormGroup.get('phoneNoFormControl').value, "").subscribe(
                createExternalUserRes => {
                  this.signUpFormGroup.reset();
                  this.modalReference.dismiss();
                  this.authService.setStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT, JSON.stringify(createExternalUserRes));
                  this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_VERIFY_DETAILS);
                },
                (error: HttpErrorResponse) => {
                  if(error.error.errors[0].code == 1104) {
                    this.userExistsError = true;
                    //alert("User email or phone number already exists.");
                   }
                }
           );
       }

      }

      //moved to TB isPasswordTyped: boolean = false;
      onPasswordInput() {

          const passwordControl = this.signInFormGroup.get('passwordFormControl');
          if (passwordControl) {
              this.isPasswordTyped = !!passwordControl.value;
          }

      }

      togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
      }

      onClickedSignIn() {
        this.showSignInError = false;

        if(this.signInFormGroup.valid) {
          this.authService.login(this.signInFormGroup.get('emailFormControl').value, this.signInFormGroup.get('passwordFormControl').value).pipe(first())
          .subscribe(
            loginResponse => {
              //console.log(loginResponse);
              this.handlePostLogin();
            },
            (errorLoginResponse: HttpErrorResponse) => {
              console.log(errorLoginResponse);
              this.showSignInError = true;
              this.signInError = errorLoginResponse.error.errors[0].message;
              //alert("Incorrect username or password for user:" + this.signInFormGroup.get('emailFormControl').value);
            }
          );
        }
      }

      onCancelLogin() {
          this.clearAuthenticationErrors();
          const wasPhoneNumberPrompt = this.showPhoneNumberForm;
          this.showSignInForm = true;
          this.showSignUpForm = false;
          this.showForgotPasswordForm = false;
          this.showResetPasswordForm = false;
          this.showPhoneNumberForm = false;
          this.verifyOTPFormGroup.reset();
          this.forgotPasswordFormGroup.reset();
          this.phoneNumberFormGroup.reset();
          this.sendOTPClicked = false;
          this.showOnClickVerifyError = false;
          this.userExistsError = false;
          this.showSignInError = false;
          this.sendOTPerror = false;
          this.phoneUpdateError = '';
          this.modalReference.dismiss();

          if (wasPhoneNumberPrompt) {
            this.router.navigateByUrl(this.getPhonePromptCloseUrl());
          }
      }

      onShowSignInFormClicked() {
        this.clearAuthenticationErrors();
        this.showSignUpForm = false;
        this.showForgotPasswordForm = false;
        this.showSignInForm = true;
      }

      onShowSignUpFormClicked() {
          this.clearAuthenticationErrors();
          console.log("onShowSignUpFormClicked");
          this.roleIdForSignUp = 3;
          this.showForgotPasswordForm = false;
          this.showSignInForm = false;
          this.showSignUpForm = true;
      }

      onShowForgotPasswordFormClicked() {
        this.clearAuthenticationErrors();
        this.showOnClickResetPasswordError = false;
        this.showOnClickVerifyError = false;
        this.userEmail = this.signInFormGroup.get('emailFormControl').value;
        this.showSignUpForm = false;
        this.showSignInForm = false;
        this.setEmailFilled();
        this.showForgotPasswordForm = true;
    }

    private clearAuthenticationErrors(): void {
      this.signUpFormGroup?.reset({
        firstNameFormControl: '',
        lastNameFormControl: '',
        emailFormControl: '',
        phoneNoFormControl: '',
        checkboxFormControl: false
      });
      [this.signInFormGroup, this.forgotPasswordFormGroup].forEach(form => {
        form?.markAsPristine();
        form?.markAsUntouched();
      });
      this.nativeGoogleSignInError = '';
      this.signInError = '';
      this.showSignInError = false;
      this.userExistsError = false;
      this.sendOTPerror = false;
      this.showOnClickVerifyError = false;
      this.showOnClickResetPasswordError = false;
    }

    get signUpFormControls() {
        return this.signUpFormGroup.controls;
      }

      get signInFormControls() {
        return this.signInFormGroup.controls;
      }

      get forgotPasswordFormControls() {
        return this.forgotPasswordFormGroup.controls;
      }

      get resetPasswordFormControls() {
        return this.resetPasswordFormGroup.controls;
      }

      get phoneNumberFormControls() {
        return this.phoneNumberFormGroup.controls;
      }

      handlePostLogin() {
        const currentUserContextValue = this.authService.getStoredItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
        const currentUserContext = currentUserContextValue ? JSON.parse(currentUserContextValue) : null;

        if (!currentUserContext?.username) {
          this.completePostLogin();
          return;
        }

        this.authService.getUserDetails(currentUserContext.username).subscribe({
          next: (userDetails: any) => {
            this.userDetails = userDetails;
            const phone = (userDetails?.phoneNumber || '').trim();
            const phoneRegex = /^[6-9][0-9]{9}$/;

            if (!phoneRegex.test(phone)) {
              this.showPhoneNumberPrompt();
              return;
            }

            this.completePostLogin();
          },
          error: (err) => {
            console.error('Failed to fetch user details after login', err);
            this.completePostLogin();
          }
        });
      }

      showPhoneNumberPrompt() {
        if (!this.phoneNumberFormGroup) {
          this.phoneNumberFormGroup = new FormGroup({
            phoneNumberFormControl: new FormControl('', [
              Validators.required,
              Validators.pattern('^[6-9][0-9]{9}$')
            ])
          });
        }

        this.showSignInForm = false;
        this.showSignUpForm = false;
        this.showForgotPasswordForm = false;
        this.showResetPasswordForm = false;
        this.showPhoneNumberForm = true;
        this.phoneUpdateError = '';
        this.phoneNumberFormGroup.reset();

        if (!this.modalReference) {
          this.modalReference = this.modalService.open(this.content, { windowClass: 'bottom-container', ariaLabelledBy: 'modal-basic-title'});
        }
      }

      onSubmitPhoneNumber() {
        this.clearPhoneUpdateError();

        if (this.phoneNumberFormGroup.invalid) {
          this.phoneNumberFormGroup.markAllAsTouched();
          return;
        }

        const phoneNumber = this.phoneNumberFormGroup.get('phoneNumberFormControl').value;
        const userParams = {
          firstName: this.userDetails.firstName,
          lastName: this.userDetails.lastName,
          phoneNumber: phoneNumber
        };

        this.authService.updateUserDetails(userParams, this.userDetails.id).subscribe({
          next: () => {
            this.userDetails.phoneNumber = phoneNumber;
            this.completePostLogin();
          },
          error: (err) => {
            console.error('Failed to update phone number after login', err);
            const duplicatePhoneError = err?.error?.errors?.find(error => error?.code === 1109);
            this.phoneUpdateError = duplicatePhoneError
              ? 'Phone number is linked to a different email address.'
              : 'Unable to update phone number. Please try again.';
          }
        });
      }

      clearPhoneUpdateError() {
        this.phoneUpdateError = '';
      }

      getPhonePromptCloseUrl() {
        const currentUserContext = this.authService.syncUserContext();

        if (currentUserContext?.roleId == 1) {
          this.authService.removeStoredItem('postLoginUrl');
          return UIRoutes.ROUTING_MODULE_TENANTS_GRID;
        }

        if (currentUserContext?.roleId == 1) {
          this.authService.removeStoredItem('postLoginUrl');
          return UIRoutes.ROUTING_MODULE_TENANTS_GRID;
        }

        if (currentUserContext?.roleId == 2) {
          this.authService.removeStoredItem('postLoginUrl');
          return UIRoutes.ROUTING_MODULE_LANDING_PAGE + '/' + UIRoutes.ROUTING_MODULE_ADMIN_BOOKINGS_PAGE;
        }

        const postLoginUrl = this.authService.getStoredItem('postLoginUrl');

        if (postLoginUrl) {
          this.authService.removeStoredItem('postLoginUrl');
        }

        const sourceUrl = postLoginUrl || this.loginAttemptUrl || this.router.url;
        const path = sourceUrl.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '');

        if (['', 'home', 'home-page', UIRoutes.ROUTING_MODULE_LOGIN,
          UIRoutes.ROUTING_MODULE_LOGIN_SUCCESS,
          UIRoutes.ROUTING_MODULE_SIGN_UP_SUCCESS.replace(/^\//, '')].includes(path)) {
          return UIRoutes.ROUTING_MODULE_PRODUCT_ALL;
        }

        return sourceUrl;
      }

      completePostLogin() {
        this.showPhoneNumberForm = false;
        this.logInStatus = true;
        this.getLoginDisplayText();

        if (this.modalReference) {
          this.modalReference.dismiss();
        }

        $(".modal-backdrop").remove();
        $(".modal-content").remove();
        this.router.navigateByUrl(this.getPhonePromptCloseUrl());
      }

      isEmailFilled() {
        return this.userEmail != '' && !this.signInFormControls.emailFormControl.hasError('invalid');
      }

      setEmailFilled() {
        if(this.isEmailFilled()) {
          this.forgotPasswordFormGroup.controls['emailFormControl'].setValue(this.userEmail);
        }
      }

      onClickedSendOTP() {
        this.showOnClickVerifyError = false;
        const emailFormControl = this.forgotPasswordFormGroup.get('emailFormControl');
        if (emailFormControl.valid) {
          emailFormControl.disable();
          this.sendOTPClicked = true;
          this.authService.sendOTP(emailFormControl.value, AppConstants.OTP_TYPE_EMAIL).subscribe(
            response => {
              this.messageToDisplayAfterOtpSent = 'OTP sent successfully';
            },
            errorResponse => {
              this.sendOTPerror = true;
              this.messageToDisplayAfterOtpSent = errorResponse.error.errors[0].message;
              /* console.error(error);
                        this.showOnClickResetPasswordError = true;
                        this.onClickResetPasswordError = error.error.errors[0].message;
               */
            }




          )
        }
      }

      getCodeBoxElement(index) {
        return (<HTMLInputElement>document.getElementById('codeBox' + index));
      }

      onKeyUpEvent(index, event) {
        this.showOnClickVerifyError = false;
        const eventCode = event.which || event.keyCode;
        // if (!this.isNumber(event)) {
        //   return false;
        // }
        if (this.getCodeBoxElement(index).value.length === 1) {
          if (index !== 4) {
            this.getCodeBoxElement(index+ 1).focus();
          } else {
            this.getCodeBoxElement(index).blur();
          }
        }
        if (eventCode === 8 && index !== 1) {
          this.getCodeBoxElement(index - 1).focus();
        }
      }

      onFocusEvent(index) {
        this.showOnClickVerifyError = false;
        for (let item = 1; item < index; item++) {
          const currentElement = this.getCodeBoxElement(item);
          if (!currentElement.value) {
              currentElement.focus();
              break;
          }
        }
      }

      checkPasswords(group: FormGroup) {
        this.showOnClickResetPasswordError = false;
        let pass = group.controls.passwordFormControl;
        let confirmPass = group.controls.reenterPasswordFormControl;
        if (
          confirmPass.errors &&
          !confirmPass.errors.confirmedValidator
        ) {
          return;
        }
        if (pass.value !== confirmPass.value) {
          confirmPass.setErrors({ confirmedValidator: true });
        } else {
          confirmPass.setErrors(null);
        }
      }

      onClickVerify() {
        this.showOnClickVerifyError = false;
        this.sendOTPerror = false;
        const otp = this.verifyOTPFormGroup.get('regotp0').value + this.verifyOTPFormGroup.get('regotp1').value
          + this.verifyOTPFormGroup.get('regotp2').value + this.verifyOTPFormGroup.get('regotp3').value;
          const email = this.isEmailFilled() ? this.userEmail : this.forgotPasswordFormGroup.get('emailFormControl').value;
          this.authService.validateOTP(email, otp, AppConstants.OTP_TYPE_EMAIL).subscribe(
            (response: any) => {
              this.showSignInForm = false;
              this.showSignUpForm = false;
              this.showForgotPasswordForm = false;
              console.log(response);
              this.showResetPasswordForm = true;
              if(response && response.accessToken) {
                this.authService.setStoredItem(AppConstants.SESSION_STORAGE_ACCESS_TOKEN, JSON.stringify(response.accessToken));
                this.authService.persistLogin();

              }
            },
            (error: HttpErrorResponse) => {
              console.log(error);
              this.showOnClickVerifyError = true;
              this.onClickVerifyError = error.error.errors[0].message;
            }
          );
          this.verifyOTPFormGroup.reset();
      }

      onClickForgotPasswordCancel() {

        this.verifyOTPFormGroup.reset();
        this. forgotPasswordFormGroup.reset();
        this.sendOTPClicked = false;
        this.showOnClickVerifyError = false;
        this.showSignUpForm = false;
        this.showForgotPasswordForm = false;
        this.showResetPasswordForm = false;
        this.showSignInForm = true;
        this.userExistsError = false;
        this.showSignInError = false;
        this.sendOTPerror = false;

      }

      onResetPasswordClicked() {

        console.log("bottom-container reset password", this.resetPasswordFormGroup);
        this.showOnClickResetPasswordError = false;

        if (this.resetPasswordFormGroup.invalid) {

            console.log("bottom-container reset password:  Invalid");
            this.showOnClickResetPasswordError = true;
            return;
        }
        else
        {
        /* (this.resetPasswordFormGroup.valid) */

          console.log('Check last 5 passwords from database');
          this.authService.resetPassword(this.resetPasswordFormGroup.get('passwordFormControl').value, this.resetPasswordFormGroup.get('reenterPasswordFormControl').value).subscribe(
            response => {
              const email = this.isEmailFilled() ? this.userEmail : this.forgotPasswordFormGroup.get('emailFormControl').value;
              alert("Password reset successfully for user: "+ email);
              this.showSignInForm = false;
              this.showSignUpForm = false;
              this.showForgotPasswordForm = false;
              this.showResetPasswordForm = false;
              this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_LOGIN).then(() => {
                window.location.reload();
            });
            },
            (error: HttpErrorResponse) => {
              console.error(error);
              this.showOnClickResetPasswordError = true;
              this.onClickResetPasswordError = error.error.errors[0].message;
            }
          );
        }

      }


}
